import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';

export function isValidRewardsPartnerUrl(url?: string | null): boolean {
  const trimmed = url?.trim();
  if (!trimmed) {
    return false;
  }
  return trimmed.startsWith('http://') || trimmed.startsWith('https://');
}

export async function openRewardsPartnerUrl(url: string): Promise<void> {
  const trimmed = url.trim();
  if (!isValidRewardsPartnerUrl(trimmed)) {
    return;
  }

  if (Capacitor.isNativePlatform()) {
    await Browser.open({ url: trimmed });
    return;
  }

  await Browser.open({ url: trimmed, windowName: '_self' });
}
